import { axiosReq } from "utils";
import { ChallengePerformanceActions } from "./ChallengePerformanceReducer";

//get challenge types
export const getWinRate = (getToken, login) => {
  return async (dispatch) => {
    try {
      const token = await getToken();

      dispatch(ChallengePerformanceActions.getWinRateRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/account/winRate/${login}`,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(ChallengePerformanceActions.getWinRateSuccess(response?.data));
    } catch (error) {
      dispatch(
        ChallengePerformanceActions.getWinRateError(
          error.response?.data.message
        )
      );
    }
    dispatch(clearStates());
  };
};

//get lots traded
export const getLotsTraded = (getToken, login) => {
  return async (dispatch) => {
    try {
      const token = await getToken();

      dispatch(ChallengePerformanceActions.getLotsTradedRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/position/lotsTraded/${login}`,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(
        ChallengePerformanceActions.getLotsTradedSuccess(response?.data)
      );
    } catch (error) {
      dispatch(
        ChallengePerformanceActions.getLotsTradedError(
          error.response?.data.message
        )
      );
    }
    dispatch(clearStates());
  };
};

//get profitable time
export const getProfitableTime = (getToken, login) => {
  return async (dispatch) => {
    try {
      const token = await getToken();

      dispatch(ChallengePerformanceActions.getProfitableTimeRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/account/profitableTime/${login}`,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(
        ChallengePerformanceActions.getProfitableTimeSuccess(response?.data)
      );
    } catch (error) {
      dispatch(
        ChallengePerformanceActions.getProfitableTimeError(
          error.response?.data.message
        )
      );
    }
    dispatch(clearStates());
  };
};

//get statistics
export const getStatistics = (getToken, login) => {
  return async (dispatch) => {
    try {
      const token = await getToken();

      dispatch(ChallengePerformanceActions.getStatisticsRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/account/statistics/${login}`,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(
        ChallengePerformanceActions.getStatisticsSuccess(response?.data)
      );
    } catch (error) {
      dispatch(
        ChallengePerformanceActions.getStatisticsError(
          error.response?.data.message
        )
      );
    }
    dispatch(clearStates());
  };
};

//clear states
export const clearStates = () => {
  return async (dispatch) => {
    setTimeout(() => {
      dispatch(ChallengePerformanceActions.clearStates());
    }, 3000);
  };
};
